import React from 'react';
import styles from './styles.module.scss'

const  ValidationErrors = ({errors}) => {
 
   return (
    <>
        {errors && errors.length > 0 && (
            <div className={styles.validation}>
                {errors.map((error,key) => 
                    <div key={key} className={styles.error}> {error} </div>  
                )}
            </div>
        )} 
    </>
  );
}

export default ValidationErrors;
